import React, { useRef, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import NavData from '../../../../config/data/nav/nav_data.json';
import useAxios from '../../../../network/useAxios';
import { programDetail, schduleList } from '../../../../network/apis/apiUri';
import { addColon } from '../../common/common_fnc';

import './css/NewsScheduleMdal.scss';

function NewsScheduleMdal() {
  const nowhm = dayjs.tz().format('HHmm');

  const history = useHistory();
  const location = useLocation();
  const { mode } = useSelector((state) => state);

  const modalEl = useRef();

  const [isWeekend, setIsWeekend] = useState(false);
  const [weekSch, setWeekSch] = useState([]);
  const [weekendSch, setWeekendSch] = useState([]);
  const [sundaySch, setSundaySch] = useState([]);
  const [modalToggle, setModalToggle] = useState(false);

  const [postData, setPostData] = useState({
    address: 'https://script.arirang.com/api/v1/bis/listScheduleV3.do',
    method: 'POST',
    headers: {},
    body: {
      data: {
        dmParam: {
          chanId: 'CH_K',
          broadYmd: dayjs.tz().day(3).format('YYYYMMDD'),
          planNo: '1',
        },
      },
    },
  });

  const [sundayPost, setSundayPost] = useState({
    ...postData,
    body: { data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().day(7).format('YYYYMMDD') } } },
  });

  const weekendPost = {
    ...postData,
    body: { data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().day(6).format('YYYYMMDD') } } },
  };

  const [scheduleList, scheduleRefetch] = useAxios(schduleList, [], postData, false);
  const [weekendScheduleList] = useAxios(schduleList, [], weekendPost, true);
  const [sundayScheduleList, sundaycheduleRefetch] = useAxios(schduleList, [], {}, false);

  const [detailItem, detailRefetch] = useAxios(programDetail, [], {}, false);
  const { data: detailData } = detailItem;

  const { data: scheduleData } = scheduleList;
  const { data: weekendData } = weekendScheduleList;
  const { data: sundayData } = sundayScheduleList;

  const programPage = (pgmCd) => {
    setModalToggle(false);
    detailRefetch({ bis_program_code: pgmCd });
  };

  const handleClickOutside = ({ target }) => {
    if (modalToggle || !modalEl.current?.contains(target)) {
      setModalToggle(false);
    }
  };

  const nextTime = (hm, run) => {
    const now = dayjs.tz().format('YYYY-MM-DD');
    const calcTime = now + addColon(hm);

    const addTime = dayjs.tz(calcTime).add(run, 'm').format('HHmm');
    return addTime;
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setModalToggle(false);
  }, [location.pathname]);

  useEffect(() => {
    if (detailData?.program_id) {
      history.push({
        pathname: `${NavData['NEWS_PROGRAM'].path}/${detailData?.program_id}`,
        state: {
          isWeekend,
          isDaily: true,
        },
      });
    }
  }, [detailData?.program_id]);

  useEffect(() => {
    sundaycheduleRefetch(sundayPost);
  }, [sundayPost]);

  useEffect(() => {
    if (scheduleData) {
      const week = scheduleData?.responseBody?.dsSchWeek.filter((el) => el.newsYn === 'Y' && el.broadClfNm === '본방');
      const weekend = weekendData?.responseBody?.dsSchWeek.filter(
        (el) => el.newsYn === 'Y' && el.broadClfNm === '본방'
      );
      const sunday = sundayData?.responseBody?.dsSchWeek.filter((el) => el.newsYn === 'Y' && el.broadClfNm === '본방');
      setWeekSch(week);
      setWeekendSch(weekend);
      setSundaySch(sunday);
    }
  }, [scheduleData, weekendData, sundayData]);

  useEffect(() => {
    let param;
    if (dayjs.tz().day() === 0 || dayjs.tz().day() === 6) {
      param = {
        ...postData,
        body: {
          data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().day(5).format('YYYYMMDD') } },
        },
      };
    } else {
      param = {
        ...postData,
        body: { data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().format('YYYYMMDD') } } },
      };
    }
    if (+dayjs.tz().day(7).format('MM') !== dayjs.tz().month() + 1) {
      setSundayPost({
        ...postData,
        body: {
          data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().day(0).format('YYYYMMDD') } },
        },
      });
    }
    setPostData(param);
    scheduleRefetch(param);
  }, [dayjs.tz().day()]);

  return (
    <section id="NewsScheduleMdal" className="newsScheduleMdal" ref={modalEl}>
      <button
        className={`btnList ${modalToggle && 'on'} ${
          location.pathname.split('/')[1] === 'news' && location.pathname.split('/')[2] === 'program' && 'active'
        }`}
        type="button"
        title={
          modalToggle
            ? mode === 'en'
              ? 'Folding the Menu'
              : '메뉴 접기'
            : mode === 'en'
            ? 'Spread the Menu'
            : '메뉴 펼치기'
        }
        onClick={() => setModalToggle(!modalToggle)}
      >
        News Schedule
      </button>
      {modalToggle ? (
        <div className="listModal" tabIndex={1}>
          <div className="listModal_list">
            <div className="listModal_list_header">
              <h4 className="title">Daily Schedule</h4>
            </div>
            {weekSch?.map((data, index) => (
              <div className="listModal_list_data" key={index}>
                {dayjs.tz().day() !== 0 &&
                  dayjs.tz().day() !== 6 &&
                  nowhm.localeCompare(data.broadHm) >= 0 &&
                  nowhm.localeCompare(nextTime(data.broadHm, data.broadRun, 'weekend')) < 0 && (
                    <div className="live">LIVE</div>
                  )}
                <button
                  type="button"
                  className="link"
                  onClick={() => {
                    programPage(data.pgmCd);
                    setIsWeekend(false);
                  }}
                >
                  <span
                    className={
                      dayjs.tz().day() !== 0 &&
                      dayjs.tz().day() !== 6 &&
                      nowhm.localeCompare(data.broadHm) >= 0 &&
                      nowhm.localeCompare(nextTime(data.broadHm, data.broadRun, 'weekend')) < 0
                        ? 'link_text on'
                        : 'link_text'
                    }
                  >
                    {addColon(data.broadHm)} {data.pgmOnm}
                  </span>
                </button>
              </div>
            ))}
          </div>
          <div className="listModal_list">
            <div className="listModal_list_header sec">
              <h3 className="title">Weekend Schedule</h3>
            </div>
            {weekendSch.map((data, index) => (
              <div
                className="listModal_list_data"
                key={index}
                onClick={() => {
                  programPage(data.pgmCd);
                  setIsWeekend(true);
                }}
              >
                {dayjs.tz().day() === 6 &&
                  nowhm.localeCompare(data.broadHm) >= 0 &&
                  nowhm.localeCompare(nextTime(data.broadHm, data.broadRun, 'weekend')) < 0 && (
                    <div className="live">LIVE</div>
                  )}
                <button type="button" className="link">
                  <span
                    className={
                      dayjs.tz().day() === 6 &&
                      nowhm.localeCompare(data.broadHm) >= 0 &&
                      nowhm.localeCompare(nextTime(data.broadHm, data.broadRun, 'weekend')) < 0
                        ? 'link_text on'
                        : 'link_text'
                    }
                  >
                    {`${addColon(data.broadHm)} ${data.pgmOnm}`}
                  </span>
                </button>
              </div>
            ))}
            {sundaySch.map((data, index) => (
              <div
                className="listModal_list_data"
                key={index}
                onClick={() => {
                  programPage(data.pgmCd);
                  setIsWeekend(true);
                }}
              >
                {dayjs.tz().day() === 7 &&
                  nowhm.localeCompare(data.broadHm) >= 0 &&
                  nowhm.localeCompare(nextTime(data.broadHm, data.broadRun, 'weekend')) < 0 && (
                    <div className="live">LIVE</div>
                  )}
                <button type="button" className="link">
                  <span
                    className={
                      dayjs.tz().day() === 7 &&
                      nowhm.localeCompare(data.broadHm) >= 0 &&
                      nowhm.localeCompare(nextTime(data.broadHm, data.broadRun, 'weekend')) < 0
                        ? 'link_text on'
                        : 'link_text'
                    }
                  >
                    {addColon(data.broadHm)} {data.pgmOnm.length > 12 ? data.pgmOnm.slice(0, -3) : data.pgmOnm}
                  </span>
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default NewsScheduleMdal;
